//PACKS
import React, { useEffect, useState } from "react";
import GoogleFontLoader from "react-google-font-loader";
import { useWindowWidth } from "@react-hook/window-size";

//COMPONENTS
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Mission from "./components/Mission";
import Products from "./components/Products";
import Contact from "./components/Contact";
import ContactModal from "./components/ContactModal";
import Footer from "./components/Footer";

// //HELPERS
// import useWindowSize from "./helpers/useWindowSize";

//STYLES
import "./App.css";

function App() {
  //HOOKS
  const [device, setDevice] = useState("");
  const [contactModalMessage, setContactModalMessage] = useState({
    status: false,
    response: "no message",
  });
  const windowWidth = useWindowWidth();

  //DEPRECATED ----------------------
  //const windowSize = useWindowSize();
  // //ON WINDOW SIZE CHANGE
  // useEffect(() => {
  //   if (windowSize.width >= 768 && windowSize.width < 1024) {
  //     setDevice("tablet");
  //   } else if (windowSize.width >= 1024) {
  //     setDevice("desktop");
  //   } else {
  //     setDevice("phone");
  //   }
  // }, [windowSize]);

  //ON WINDOW WIDTH CHANGE
  useEffect(() => {
    if (windowWidth >= 768 && windowWidth < 1024) {
      setDevice("tablet");
    } else if (windowWidth >= 1024) {
      setDevice("desktop");
    } else {
      setDevice("phone");
    }
    // console.log(windowWidth);
  }, [windowWidth]);

  function handleContactModal(message) {
    setContactModalMessage(message);
    console.log(message);
  }

  return (
    <div className="App">
      <GoogleFontLoader
        fonts={[
          {
            font: "Oswald",
            weights: [400, "400i"],
          },
        ]}
        subsets={["cyrillic-ext", "greek"]}
      />
      <Navbar device={device} />
      <Hero device={device} />
      <Mission device={device} />
      <Products device={device} />
      <Contact
        device={device}
        handleContactModal={handleContactModal.bind(this)}
      />
      <ContactModal contactModalMessage={contactModalMessage} />
      <Footer device={device} />
    </div>
  );
}

export default App;
